import * as React from 'react';

import {useMutation} from '@apollo/react-hooks';

import {Button} from 'shells/button/button';
import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';

import type {
    PauseDripSequence as PauseDripSequenceMutation,
    PauseDripSequenceVariables as PauseDripSequenceMutationVariables,
} from 'nutshell-graphql-types';

import DRIP_SEQUENCE_PAUSE from './graphql/mutations/drip-sequence-pause.graphql';

type Props = {
    disabled: boolean;
    dripSequenceId: string;
    onPaused: () => void;
};

export function PauseSequenceButton(props: Props) {
    const [isPausingSequence, setIsPausingSequence] = React.useState<boolean>(false);
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const [pauseDripSequence] = useMutation<
        PauseDripSequenceMutation,
        PauseDripSequenceMutationVariables
    >(DRIP_SEQUENCE_PAUSE);

    return (
        <>
            <Button
                disabled={props.disabled}
                variant='primary'
                size='big'
                onClick={() => {
                    setIsPausingSequence(true);
                }}
            >
                Pause sequence
            </Button>
            {isPausingSequence ? (
                <ConfirmationDialog
                    title='Pause drip sequence'
                    message='Are you sure you’d like to pause? Current recipients will remain queued and you can resume sending to them at any time.'
                    confirmText='Yes, pause'
                    cancelText='No, don’t pause'
                    isConfirmDestructive={false}
                    onCancel={() => setIsPausingSequence(false)}
                    onConfirm={() => {
                        setIsSaving(true);

                        return pauseDripSequence({
                            variables: {
                                input: {
                                    dripSequenceId: props.dripSequenceId,
                                },
                            },
                        }).then(() => {
                            setIsSaving(false);

                            // Timeout just keeps dialog open a little longer to see the save is confirmed
                            setTimeout(() => {
                                props.onPaused();
                                setIsPausingSequence(false);
                            }, 1000);
                        });
                    }}
                    isSaving={isSaving}
                    customSaveText={{
                        initial: 'Yes, pause',
                        saving: 'Pausing…',
                        complete: 'Paused',
                    }}
                />
            ) : undefined}
        </>
    );
}
